import React from "react";
import { CheckIcon, GlobeIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
const perks = ["Instant digital delivery", "One-time payment", "No subscriptions", "7-day money-back guarantee"];
export function SpecialOfferBanner() {
  return <section className="bg-plum px-4 py-12 text-white" aria-labelledby="special-offer-title" data-id="element-266" data-mp="1wx5c8agxflgw">
      <div className="mx-auto max-w-3xl text-center" data-id="element-267" data-mp="1ryc7b6fph2sc">
        <p className="text-xs font-bold uppercase tracking-[0.14em] text-rose-soft sm:text-sm" data-id="element-268" data-mp="1nzv06mwabsax">
          The special offer is available now
        </p>
        <h2 id="special-offer-title" className="mt-3 text-balance font-serif text-3xl font-bold leading-tight sm:text-4xl" data-id="element-269" data-mp="1j237vrrqa467">
          Get the complete Menopause Decision Map™ system for just{" "}
          <span className="whitespace-nowrap text-[#FFD7E3]" data-id="element-270" data-mp="193xb1oks3o87">$27.</span>
        </h2>
        <ul className="mx-auto mt-6 grid max-w-xl grid-cols-1 gap-2.5 text-left sm:grid-cols-2" data-id="element-271" data-mp="38ckkwbii01ru">
          {perks.map(perk => <li key={perk} className="flex items-center gap-2.5 text-[16px] font-medium" data-id="element-272" data-mp="bkjqrrucpqq8">
              <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-cta" data-id="element-273" data-mp="gjd85vcre1vo">
                <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-274" data-mp="1mcdbiz9tqsz" />
              </span>
              {perk}
            </li>)}
        </ul>
        <p className="mx-auto mt-6 flex max-w-xl items-start justify-center gap-2 text-sm text-white/80" data-id="element-275" data-mp="6lpbgzvlekav">
          <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-276" data-mp="ubjnxgc026ul" />
          Your currency will be calculated automatically according to your country at checkout, where supported.
        </p>
        <CtaButton className="mt-8" label="Claim my $27 access now" data-id="element-277" data-mp="kkootbdnncrq" />
      </div>
    </section>;
}